import { Injectable } from '@angular/core';

/**
 * Runtime configuration for the Customer Chat BFF.
 *
 * Mirrors the `ApiConfiguration` pattern: the default is overridden at the app level from
 * `environment` (libs never import `environment`). The BFF is a DIFFERENT origin than
 * `ApiConfiguration.rootUrl`, so the `apiAuthorizationToken` interceptor does NOT attach the bearer
 * token to BFF requests — `CustomerChatClient` sets the `Authorization` header explicitly.
 */
@Injectable({ providedIn: 'root' })
export class CustomerChatConfig {
  /** Base URL of the Customer Chat BFF, e.g. `http://localhost:3003` (interim until Aspire — M8). */
  public baseUrl = '';
}
